// MOCK DATA for Davide Lepido - Sound Engineer website clone
// NOTE: all content below is MOCKED for the frontend-only teaser.

export const CONTACT = {
  name: "Davide Lepido",
  role: "Sound Engineer",
  phone: "+39 349 6701167",
  phoneRaw: "+393496701167",
  email: "davide.lepido@gmail.com",
  location: "Milano, Lombardia",
};

export const NAV = [
  { id: "home", label: "HOME" },
  { id: "social", label: "SOCIAL" },
  { id: "studio", label: "STUDIO" },
  { id: "services", label: "SERVICES" },
  { id: "bio", label: "BIO" },
  { id: "plugin", label: "PLUGIN Café" },
  { id: "contacts", label: "CONTACTS" },
  { id: "credits", label: "CREDITS" },
];

export const IMAGES = {
  heroGuitar: "https://images.unsplash.com/photo-1567876520868-1fb3fef987fc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwzfHxndWl0YXIlMjBzdHJpbmdzfGVufDB8fHxibGFja19hbmRfd2hpdGV8MTc5MTIwNjczMnww&ixlib=rb-4.1.0&q=85",
  mic1: "https://images.unsplash.com/photo-1531651008558-ed1740375b39?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxzdHVkaW8lMjBtaWNyb3Bob25lfGVufDB8fHxibGFja19hbmRfd2hpdGV8MTc5MTIwNjczMnww&ixlib=rb-4.1.0&q=85",
  mic2: "https://images.unsplash.com/photo-1615821430614-3d7d2685e2f2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxzdHVkaW8lMjBtaWNyb3Bob25lfGVufDB8fHxibGFja19hbmRfd2hpdGV8MTc5MTIwNjczMnww&ixlib=rb-4.1.0&q=85",
  console1: "https://images.unsplash.com/photo-1535406208535-1429839cfd13?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxtaXhpbmclMjBjb25zb2xlfGVufDB8fHxibGFja19hbmRfd2hpdGV8MTc5MTIwNjczMnww&ixlib=rb-4.1.0&q=85",
  console2: "https://images.unsplash.com/photo-1600862709234-1da437501381?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwzfHxtaXhpbmclMjBjb25zb2xlfGVufDB8fHxibGFja19hbmRfd2hpdGV8MTc5MTIwNjczMnww&ixlib=rb-4.1.0&q=85",
  studioRoom: "https://images.unsplash.com/photo-1589154904762-c258f3497b6b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHw0fHxyZWNvcmRpbmclMjBzdHVkaW98ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzkxMjA2NzYwfDA&ixlib=rb-4.1.0&q=85",
  live: "https://images.unsplash.com/photo-1620577610365-86c411bad78d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxsaXZlJTIwY29uY2VydCUyMHNvdW5kfGVufDB8fHxibGFja19hbmRfd2hpdGV8MTc5MTIwNjc2MHww&ixlib=rb-4.1.0&q=85",
  portrait: "https://customer-assets-7cd3h4nn.emergentagent.net/job_sound-engineer-d/artifacts/5wbx0se7_4F63265D-9707-4048-9AAE-2674574A0A02.PNG",
  producer: "https://images.unsplash.com/photo-1531651750200-b2c2b3ddc876?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHxyZWNvcmRpbmclMjBzdHVkaW98ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzkxMjA2NzYwfDA&ixlib=rb-4.1.0&q=85",
  studioReal: "https://customer-assets-7cd3h4nn.emergentagent.net/job_sound-engineer-d/artifacts/zbapkhzu_IMG_7722_edited.webp",
  studioReal2: "https://customer-assets-7cd3h4nn.emergentagent.net/job_sound-engineer-d/artifacts/2gmk4a1o_IMG_7117_Original_edited.webp",
  studioReal3: "https://customer-assets-7cd3h4nn.emergentagent.net/job_sound-engineer-d/artifacts/etfbdj07_BCEF7ABD-2D0D-45C3-A021-5BC75E327D8F_Original.webp",
};

export const PROMO_VIDEO_ID = "8xpDRc6y0GY";

export const LOGO = "https://customer-assets-7cd3h4nn.emergentagent.net/job_sound-engineer-d/artifacts/ny9tvocl_LOGO%20LEPIDO%20INV.webp";

export const LOGO_DARK = "https://customer-assets-7cd3h4nn.emergentagent.net/job_sound-engineer-d/artifacts/fii64mq1_LOGO%20LEPIDO%20TRASP.webp";

export const DL_MASCOT = "https://customer-assets-7cd3h4nn.emergentagent.net/job_sound-engineer-d/artifacts/1u8a0by7_DL2.webp";

export const SIGLA_VIDEO = "https://customer-assets-7cd3h4nn.emergentagent.net/job_sound-engineer-d/artifacts/j3pnbhd9_Davide%20Lepido%20Sigla%202.mp4";

export const INTRO_VIDEO = "https://customer-assets-7cd3h4nn.emergentagent.net/job_sound-engineer-d/artifacts/0yio3hl5_Davide%20Lepido%20Sigla%202.mp4";

export const SOCIALS = [
  { name: "Instagram", handle: "@davidelepido", url: "https://www.instagram.com/davidelepido/", icon: "Instagram" },
  { name: "Facebook", handle: "Davide Lepido", url: "https://www.facebook.com/lepidodavide", icon: "Facebook" },
];

export const STUDIO = {
  intro:
    "Uno spazio costruito nel tempo, trattato acusticamente e pensato per far suonare al meglio ogni strumento. Dalla ripresa microfonica al mix finale, tutto accade qui.",
  gallery: [
    { src: "studioReal", caption: "Console & outboard" },
    { src: "mic1", caption: "Sala ripresa" },
    { src: "studioReal2", caption: "Control room" },
    { src: "studioReal3", caption: "Vocal booth" },
  ],
  gear: [
    "Universal Audio Apollo",
    "Neumann U87",
    "SSL / Neve preamps",
    "Yamaha NS-10 / Focal",
    "Pro Tools HDX",
    "Trattamento acustico su misura",
  ],
};

export const SERVICES = [
  { icon: "Mic", title: "Recording", desc: "Ripresa microfonica di voci e strumenti con setup di alto livello." },
  { icon: "Scissors", title: "Editing", desc: "Editing dettagliato, tuning, timing e comping di ogni traccia." },
  { icon: "SlidersHorizontal", title: "Mixing", desc: "Mix analogico e digitale per dare profondità e carattere al brano." },
  { icon: "Speaker", title: "Live Sound", desc: "Service e direzione del suono per concerti ed eventi dal vivo." },
  { icon: "Clapperboard", title: "Post-produzione", desc: "Sound design e audio post per video, spot e contenuti." },
];

export const BIO = {
  text: [
    "Davide Lepido è un fonico e producer con base a Milano. Da oltre dieci anni lavora tra studio di registrazione e palco, curando il suono di artisti, band e progetti discografici.",
    "La sua filosofia è semplice: mettere la tecnica al servizio della musica. Ogni progetto parte dall'ascolto, per trovare il suono giusto senza mai perdere l'emozione della performance.",
    "Dalla ripresa live al mix finale, segue l'intero flusso di produzione con attenzione maniacale ai dettagli.",
  ],
  stats: [
    { value: "10+", label: "Anni di esperienza" },
    { value: "250+", label: "Progetti seguiti" },
    { value: "80+", label: "Artisti" },
  ],
};

export const PLUGIN_CAFE = {
  intro:
    "Plugin Café è il mio angolo dedicato agli strumenti del mestiere: recensioni, consigli e preset per chi ama il suono. Un caffè e due chiacchiere sul mondo dell'audio.",
  items: [
    { name: "FabFilter Pro-Q 3", tag: "EQ", note: "L'equalizzatore che uso su quasi ogni mix." },
    { name: "Valhalla VintageVerb", tag: "Reverb", note: "Riverbero versatile dal carattere vintage." },
    { name: "UAD 1176 / LA-2A", tag: "Compressor", note: "Compressione sulla voce con sapore analogico." },
    { name: "Soothe 2", tag: "Dynamic EQ", note: "Per domare risonanze e asprezze." },
  ],
};

export const EPISODES = [
  { ep: 1, id: "RZJQguKNMGI", title: "Arturia Memory Brigade" },
  { ep: 2, id: "F0wYunU9HmM", title: "SSL (Alliance) vs SSL (Waves)" },
  { ep: 3, id: "GEiqaSjMwHA", title: "Fender 55 Deluxe UAD" },
  { ep: 4, id: "S1AKXii-5m8", title: "Soundtoys Tremolator" },
  { ep: 5, id: "Et1ZE3YJiY4", title: "UAD Distressor" },
  { ep: 6, id: "ssEHkxug4kQ", title: "UAD API 2500" },
  { ep: 7, id: "_uKVWc15UYA", title: "Arturia Delay Tape 201" },
  { ep: 8, id: "Oo05Sg_aUME", title: "Slate Trigger 2" },
  { ep: 9, id: "etS5oc5FVXA", title: "FabFilter Pro-R" },
  { ep: 10, id: "4n7J3BO-zgI", title: "Waves TG 12345" },
  { ep: 11, id: "ravA-dKPqNQ", title: "UAD Ocean Way Studios" },
  { ep: 12, id: "lo-iaAiRYYg", title: "Arturia Pre 1973" },
  { ep: 13, id: "n3huUwYomS0", title: "Alliance bx_console N" },
  { ep: 14, id: "-YI9LlTsslw", title: "Alliance SVT vs UAD SVT" },
  { ep: 15, id: "C3oYkH8_dGs", title: "Eventide Blackhole" },
  { ep: 16, id: "NjZ63OBsRFE", title: "Alliance Townhouse" },
  { ep: 17, id: "HNRVjkrgeTU", title: "Arturia Rev Plate 140" },
  { ep: 18, id: "Ou3tzSsU5JY", title: "Softube Drawmer S73" },
  { ep: 19, id: "yPJi_7Bk2Rs", title: "Alliance Maag EQ4" },
  { ep: 20, id: "XLHTaFuyY74", title: "Soundtoys Little Plate" },
  { ep: 21, id: "KJbYp3o1OiE", title: "AudioThing Type A" },
  { ep: 22, id: "xxUNd5u0LEc", title: "UAD Pure Plate Reverb" },
  { ep: 23, id: "r0nz3k1zFaQ", title: "Waves RBass" },
  { ep: 24, id: "kK1CgsG8d44", title: "Valhalla Supermassive" },
  { ep: 25, id: "hS7IsQvC21Q", title: "FabFilter Pro-G" },
  { ep: 26, id: "xRq8ML6Zxwo", title: "SSL X-Comp" },
  { ep: 27, id: "MtZX3aTe5Tw", title: "UAD Ocean Way" },
  { ep: 28, id: "_gBWYWZkBwI", title: "UAD Neve 1073 + Raw Distortion" },
];

export const CREDITS = {
  assistant: [
    "Pooh", "Lacuna Coil", "Morphium", "Gianna Nannini", "Benji e Fede",
    "Marco Barusso", "Cristiano Malgioglio", "Fred de Palma", "Paolo Meneguzzi", "Misfatto",
  ],
  liveStudio: [
    "Danilo Sacco", "Sasha Torrisi", "Omar Pedrini", "Dave Weckl", "Frank Gambale", "Luca Colombo",
    "Franco Mussida", "Arianna Ferrari",
    "Marco Masini", "Fausto Leali", "Gianluca Grignani", "Mike Stern", "Davide Van De Sfroos",
    "Giorgio Vanni", "Ivana Spagna", "Matteo Bianchi", "Bryan Kazzaniga", "Nando Bonini",
    "Sticky Fingers", "Rockhestra", "Pliskin", "gli Swami", "Antigua", "Nosolly", "The Dopes",
    "Marco Mantovani", "Nicole Stella", "Martian Patriots", "Another Story", "The Presence",
    "Old Broken Radio", "Flower And The Powers", "Lombroso", "I Camaleonti", "Livio Macchia",
    "Stereocut", "il disagio di Mafalda", "Osvaldo Lo Iacono", "Riccardo Oliva", "Vittorio Romano",
    "Vittorio Cosma", "Ain\u00e9", "Mauro Durante", "Antonio Petruzzelli", "Enrico Merlin",
    "Ze in the Clouds", "Stefano Pisetta", "Fabio Celenza", "Enrico Wolgang Cavion", "Ernia",
    "Germano Lanzoni", "Paolo Costa", "Lele Melotti", "Daniela Pes", "Nico Berardi",
    "Moreno \u201cil Biondo\u201d Conficconi",
  ],
};
